module.exports = __webpack_public_path__ + "static/media/two.f81ec06c.jpg";